<template lang="pug">
  a.baseButton_link(
    :class="{'is-disabled' : isDisabled}"
    @click="$emit('click')"
  )
    slot
</template>
<script>
export default {
  props: {
    isDisabled: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style lang="scss">
@import "@design";
.baseButton_link {
  background: $color-body-bg;
  font-weight: $heading-font-weight;
  text-align: center;
  text-transform: uppercase;
  text-decoration: none;
  display: block;
  padding: 1rem;
  letter-spacing: 0.13em;
  border-radius: 5rem;
  border: 1px solid $primary-color;
  cursor: pointer;
  &,
  &:active,
  &:visited {
    color: $primary-color;
  }
  &:hover,
  &:hover span {
    background: $primary-color;
    color: $color-body-bg;
  }
  span {
    vertical-align: middle;
    padding-right: 1rem;
    svg {
      height: 0.875rem;
    }
  }
  &.is-disabled {
    color: $primary-dark-color;
    border: 1px solid $primary-dark-color;
    cursor: default;
    &:hover,
    &:hover span {
      background: $color-body-bg;
      color: $primary-dark-color;
    }
  }
  @media (min-width: $vh-tablet) {
    display: inline-block;
    width: auto;
    border: none;
    padding: 1rem 1rem 1rem 1rem;
    &:hover {
      background: rgba(0, 0, 0, 0);
      color: $primary-color;
    }
    span {
      vertical-align: baseline;
      border: 1px solid $primary-color;
      padding: 0.95rem 1.1rem;
      margin-right: 1rem;
      border-radius: 50%;
    }
    &.is-disabled {
      color: $primary-dark-color;
      border: none;
      cursor: default;
      & span {
        border: 1px solid $primary-dark-color;
      }
      &:hover,
      &:hover span {
        background: $color-body-bg;
        color: $primary-dark-color;
      }
    }
  }
}
</style>
